import { actionCreatorsFor } from '../common/redux-crud-actions'

const defaultActions = actionCreatorsFor('schedules')

/**
 * Returns an action to add a schedule config to the exiting schedules.
 *
 * @param {string} key - Resource key of the scheduler
 * @param {string} path - Scheduler path to the resource
 * @return {ReduxAction}
 */
const addSubscription = function (key, path) {
    return defaultActions.patchMergePatchJsonSuccess({
        [key]: path
    })
}
/**
 * Returns an action to remove a schedule config from the exiting schedules.
 *
 * @param {string} key - Resource key of the scheduler
 * @return {ReduxAction}
 */
const removeSubscription = function (key) {
    return defaultActions.patchMergePatchJsonSuccess({
        [key]: null
    })
}

/**
 * Actions for adding schedules for cyclic refresh to the store
 */
export const schedulesActions = defaultActions

export const publicSchedulesActions = {
    addSubscription,
    removeSubscription
}
